import type { GameState } from "./model";
import { positionKey } from "./notation";

export const REPETITION_DRAW_COUNT = 3;

export function positionOccurrenceCount(positionHistory: readonly string[], key: string): number {
  let count = 0;
  for (const prior of positionHistory) {
    if (prior === key) count += 1;
  }
  return count;
}

export function isThreefoldRepetition(
  positionHistory: readonly string[],
  state: GameState,
): boolean {
  return positionOccurrenceCount(positionHistory, positionKey(state)) >= REPETITION_DRAW_COUNT;
}
